import React from 'react';
import { stencilFiducialData } from 'pu-data/SelectOptions';
import { stencilFiducialData as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './SelectComponent';

const StencilFiducialData = (props) => {
  const { parameters, name } = props;
  const onChange = e => props.onChangeParameter(props.name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={props.groupName}
      errorMessage={props.errorMessage} />
  );
};

StencilFiducialData.defaultProps = {
  label: 'Fiducial Data',
  name: 'fiducial_data',
  options: stencilFiducialData,
  required: true,
};

export default StencilFiducialData;
